import { Actions } from '../enums/ActionEnums';
import { ActionType } from '../models/appContext';
import { CompanyType } from '../models/company';

export const companyReducer = (state: CompanyType, action: ActionType): CompanyType => {
  switch (action.type) {
    case Actions.SetSelectedCompany:
      return {
        name: action.payload.name,
        address_name: action.payload.address_name
      };
    case Actions.ResetSelectedCompany:
      return {
        name: null,
        address_name: null
      };
    default:
      return state;
  }
};
